module.exports = __webpack_public_path__ + "static/fanta-3-c698c400f5eae3cee72e7841f110181f.jpg";